export default __webpack_public_path__ + "static/media/gift.aaab8b00.svg";